import { ManageLabelModalLabel } from 'interfaces/labels/ManageLabelModalLabel'

export const getUniqueIdentifier = (label: ManageLabelModalLabel) =>
  `${label?.code || ''}${label?.value || ''}${label?.name || ''}`
